export default "<div *ngIf=\"hasLoaded\">\n    <header></header>\n    <router-outlet></router-outlet>\n    <footer></footer>\n</div>"